/*
 Flagship SHIFT Config
 */

const markets = [
  "Birmingham",
  "Cincinnati",
  "Cleveland",
  "Columbus",
  "Detroit",
  "Indianapolis",
  "Nashville",
];

const services = [
  {
    value: "analytics",
    text: "Analytics",
    flighted: false,
  },
  {
    value: "blog",
    text: "Blog",
    flighted: false,
  },
  {
    value: "display",
    text: "Display",
    subOptions: [
      { value: "device-id", text: "Device ID", flighted: true },
      { value: "ip-targeting", text: "IP Targeting", flighted: true },
      { value: "microproximity", text: "Microproximity", flighted: true },
      { value: "mobile-expandable", text: "Mobile Expandable", flighted: true },
      { value: "native", text: "Native", flighted: true },
      {
        value: "outreach-retargeting",
        text: "Outreach/Retargeting",
        flighted: true,
      },
      {
        value: "foot-traffic-attribution",
        text: "Foot Traffic Attribution",
        flighted: true,
      },
    ],
  },
  {
    value: "email-marketing",
    text: "Email Marketing",
    flighted: false,
  },
  {
    value: "ott-ctv",
    text: "OTT / CTV",
    subOptions: [
      { value: "generic-ctv", text: "Package 1: Generic Connected TV" },
      { value: "targeted-ctv", text: "Package 2: Targeted Connected TV" },
      { value: "generic-ott", text: "Package 3: Generic Over-the-Top" },
      {
        value: "targeted-ott",
        text: "Package 4: Targeted Over-the-Top",
        flighted: true,
      },
    ],
  },
  {
    value: "ppc",
    text: "Pay-Per-Click",
    flighted: true,
  },
  {
    value: "gmb",
    text: "Google My Business",
    flighted: false,
  },
  {
    value: "seo",
    text: "Search Engine Optimization",
    flighted: false,
  },
  {
    value: "social-media",
    text: "Social Media",
    subOptions: [
      {
        value: "social-media-management",
        text: "Full Social Media Management",
        flighted: false,
      },
      {
        value: "social-media-ads",
        text: "Social Media Ads Only",
        flighted: true,
      },
      {
        value: "social-media-refresh",
        text: "Social Media Refresh",
        flighted: false,
      },
      {
        value: "social-media-sweepstakes",
        text: "Social Media Sweepstakes",
        flighted: false,
      },
      {
        value: "social-media-influencers",
        text: "Social Media Influencers",
        flighted: false,
      },
    ],
  },
  {
    value: "video",
    text: "Video Production",
    flighted: false,
  },
  {
    value: "website",
    text: "Website",
    subOptions: [
      {
        value: "website-redesign",
        text: "Full Web Design & Development",
        flighted: false,
      },
      {
        value: "website-update",
        text: "Existing Website Update",
        flighted: false,
      },
      {
        value: "website-campaign-landing-page",
        text: "Campaign Landing Page (Performance)",
        flighted: false,
      },
      {
        value: "website-landing-page",
        text: "Legacy Landing Page (Traditional/WordPress)",
        flighted: false,
      },
      {
        value: "website-hosting",
        text: "Web Hosting Renewal",
        flighted: false,
      },
    ],
  },
  {
    value: "youtube",
    text: "YouTube",
    flighted: true,
  },
];

export default {
  markets: markets,
  lineItemServices: services,
  logo: "/assets/shift-logo.png",
  userGroups: [
    "Content & Influencers",
    "Creative",
    "Data & Analytics",
    "Paid Media",
    "Proposal Strategy",
    "QA & Support",
    "Web & SEO",
    "Other",
  ],
};



// WEBPACK FOOTER //
// ./src/config/instances/SHIFT.js